module.exports = __webpack_public_path__ + "static/gallery5-79605bd029dc2d33630801dc64b90855.png";